import infoJson from './info.json';

type Info = {
  [lang: string]: {
    displayName: string;
    displayNameEn: string;
    rtl?: boolean;
  };
};

export const info: Info = infoJson;
